
/* global globalThis */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Drawer, Divider, List, ListItem, ListItemText, Box, Typography, Link, withStyles } from '@material-ui/core';
import './MobieSidebar.scss';
import logo from "../../../assets/images/LearnifyLogoDark.png";
import { ReactComponent as AllCoursesIconDark } from "../../../assets/images/allCoursesIconDark.svg";
import { ReactComponent as AllCoursesIconLight } from "../../../assets/images/allCoursesIconlight.svg";
import { ReactComponent as SurveyIconDark } from "../../../assets/images/surveyIconDark.svg";
import { ReactComponent as SurveyIconLight } from "../../../assets/images/surveyIconLight.svg";
import { ReactComponent as SupportIconDark } from "../../../assets/images/supportIconDark.svg";
import { ReactComponent as SupportIconLight } from "../../../assets/images/supportIconLight.svg";
import { ReactComponent as LanguageIconDark } from "../../../assets/images/languageIconDark.svg";
import { ReactComponent as LanguageIconLight } from "../../../assets/images/languageIconLight.svg";
import { ReactComponent as LogoutIconDark } from "../../../assets/images/logoutIconDark.svg";
import { useTranslations, useUrlInfo } from "examsbook-react-sdk/custom-hooks";
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ColorsConstant } from "../../../constants/colorConstant";
import status from "examsbook-react-sdk/constants/actionStatus.js";
import { useDispatch, useSelector } from "react-redux";
import { setSubdomain } from "examsbook-react-sdk/actions/getSettingsAction";
import { getUserCourseGroup } from 'examsbook-react-sdk/actions';
import Cookies from 'js-cookie';
import { logoutUser } from "examsbook-react-sdk/services/userService";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

function MobileViewSideBar({ openToggler, toggleDrawer, classes, user }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslations();
  const [open, setOpen] = useState(false)
  const [dynamicLogos, setDynamicLogos] = useState('');
  const [selectedItem, setSelectedItem] = useState('dashboard');
  const [selectedIcon, setSelectedIcon] = useState('dashboardIcon');
  const [selectedMenu, setSelectedMenu] = useState("/dashboard");
  const settings = useSelector((state) => state.settingsReducers);
  const isLoadingSettings = settings.status === status.PENDING;
  const settingsData = React.useMemo(() => settings.settingsData?.data || [], [settings.settingsData]);
  const { currentHost } = useUrlInfo();
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const [hasCoursePackages, setHasCoursePackages] = useState(false);

  useEffect(() => {
    const fetchCoursePackages = async () => {
      if (!userId) {
        setHasCoursePackages(false);
        return;
      }
      try {
        const response = await Promise.resolve(dispatch(getUserCourseGroup(userId, 0, 1)));
        setHasCoursePackages(Array.isArray(response?.data) && response.data.length > 0);
      } catch (error) {
        console.error("Failed to fetch course packages:", error);
        setHasCoursePackages(false);
      }
    };
    fetchCoursePackages();
  }, [dispatch, userId]);

  const handleLogout = async () => {
    logoutUser()
      .then((response) => {
        if (response?.status === 200) {
          localStorage.clear();
          Object.keys(Cookies.get()).forEach((cookieName) => {
            Cookies.remove(cookieName, {
              path: "/",
              domain: currentHost,
              secure: true,
            });
          });

          dispatch(setSubdomain(null));
          toggleDrawer(false);
          globalThis.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "LOGOUT",
            })
          );

          const returnToUrl = response?.data?.returnToUrl;

          if (
            process.env.NODE_ENV === "production" ||
            process.env.NODE_ENV === "staging"
          ) {
            globalThis.location.href = returnToUrl;
          } else {
            globalThis.location.href = "/login";
          }
        } else {
          console.log("Something went wrong during logout.");
        }
      })
      .catch((error) => {
        console.log(error.message)
      });
  };

  const handleLogoRedirection = () => {
    toggleDrawer(false)
    history.push('/dashboard')
  };

  const handleItemClick = (item, icon) => {
    setSelectedItem(item);
    setSelectedIcon(icon);
      toggleDrawer(false);
  };
  useEffect(() => {
      if (!isLoadingSettings) {
      const imageValue = settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
      setDynamicLogos(imageValue || logo);
      }
    }, [isLoadingSettings, settingsData])

  useEffect(() => {
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/course")) {
      setSelectedItem("courses");
      setSelectedIcon("courseIcon");
    } else if (path.includes("/course-package")) {
      setSelectedItem("coursePackage");
      setSelectedIcon("coursePackageIcon");
    } else if (path.includes("/change-language")) {
      setSelectedItem("language");
      setSelectedIcon("languageIcon");
    } else if (path.includes("/surveys")) {
      setSelectedItem("survey");
      setSelectedIcon("surveyIcon");
    } else if (path.includes("/support-ticket")) {
      setSelectedItem("support");
      setSelectedIcon("supportIcon");
    } else {
      setSelectedItem("");
      setSelectedIcon("");
    }
  }, [location.pathname]);     
  
  const list = (
    <Box>
      <List>
        {!isLoadingSettings && <Box className="listDiv">
          <button
            type="button"
            aria-label="Go to dashboard"
            onClick={handleLogoRedirection}
            style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
          >
            <img alt="Learnify logo" src={dynamicLogos || logo} className="logo-size" />
          </button>
            <ArrowBackIcon onClick={() => toggleDrawer(false)} />
        </Box>}
        <ListItem button className={`listItem ${selectedItem === 'courses' ? classes.selected : ''}`} onClick={() =>  {handleItemClick('courses', 'courseIcon'); setOpen(!open)}}>
          <Box className='icon-height'>
            {selectedIcon === 'courseIcon' ? <AllCoursesIconLight/> : <AllCoursesIconDark/>}
          </Box>
          <ListItemText primary={t('COURSES')} className="listItemText"
            onClick={() => {
              setSelectedMenu('/courses');
              history.push('/courses');
            }}
          />
        </ListItem>
        {hasCoursePackages && (
          <ListItem button className={`listItem ${selectedItem === 'coursePackage' ? classes.selected : ''}`}
            onClick={() => {
              handleItemClick('coursePackage', 'coursePackageIcon');
              setSelectedMenu('/course-package');
              history.push('/course-package');
            }}
          >
            <Box className='icon-height'>
              <LibraryBooksIcon style={{ fill: selectedIcon === 'coursePackageIcon' ? '#fff' : '#0c3450' }}/>
            </Box>
            <ListItemText primary={t('Course Package')} className="listItemText" />
          </ListItem>
        )}
        <ListItem button className={`listItem ${selectedItem === 'language' ? classes.selected : ''}`}
          onClick={() => {
            handleItemClick('language', 'languageIcon');
            setSelectedMenu('/change-language');
            history.push('/change-language');
            setOpen(!open)
          }}
        >
        <Box className='icon-height'>
          {selectedIcon === 'languageIcon' ? <LanguageIconLight/> : <LanguageIconDark/>}
        </Box>
          <ListItemText primary={t('LANGUAGE')} className="listItemText"  />
        </ListItem>

        <ListItem button className={`listItem ${selectedItem === 'survey' ? classes.selected : ''}`} onClick={() => handleItemClick('survey', 'surveyIcon')}>
          <Box className='icon-height'>
          {selectedIcon === 'surveyIcon' ? <SurveyIconLight/> : <SurveyIconDark/>}
          </Box>
          <ListItemText primary={t('Surveys')} className="listItemText"
            onClick={() => {
              setSelectedMenu('/surveys');
              history.push('/surveys');
            }}
          />
        </ListItem>
        <ListItem button className={`listItem ${selectedItem === 'support' ? classes.selected : ''}`} onClick={() => handleItemClick('support', 'supportIcon')}>
          <Box className='icon-height'>
          {selectedIcon === 'supportIcon' ? <SupportIconLight/> : <SupportIconDark/>}
          </Box>
          <ListItemText primary={t('Support')} className="listItemText"
            onClick={() => {
              setSelectedMenu('/support-ticket');
              history.push('/support-ticket');
            }}
          />
        </ListItem>
        <ListItem
          button
          className="listItem"
          onClick={() => globalThis.open('https://docs.learnify.ing', '_blank')}
        >
          <Box className='icon-height'>
            <MenuBookIcon style={{ fill: '#0c3450' }}/>
          </Box>
          <ListItemText primary={t('User Manual')} className="listItemText" />
        </ListItem>
        <Divider className="divider-align"></Divider>
        <ListItem button className="listItem" onClick={() => handleLogout()}>
          <Box className='icon-height'>
            <LogoutIconDark/>
          </Box>
          <ListItemText primary={t('logout')} className="listItemText" />
        </ListItem>
        <Box>
            <Typography className='powered-by'>
              &copy; {t('Powered by')}&nbsp;
              <Link href="https://www.habilelabs.io/" rel="noopener noreferrer" target="_blank" id='habilelabs-text'>{t('HabileLabs')}</Link>
            </Typography>
        </Box>
      </List>
    </Box>
  );
  return (

    <Drawer open={openToggler} className='drawe' onClose={() => toggleDrawer(false)} style={{ width: '100% !important' }}>
      {list}
    </Drawer>


  );
}

MobileViewSideBar.propTypes = {
  openToggler: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  classes: PropTypes.shape({
    selected: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    user: PropTypes.shape({
      _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  })
};

const useStyles = (themes) => {
  const themeData =  localStorage.getItem('theme');
  const theme = JSON?.parse(themeData)
  let primaryColor = ""
  let primaryFontText = ""
  if (theme !== undefined) {
    primaryColor = JSON.parse(themeData)?.primaryBg
    primaryFontText = JSON.parse(themeData)?.primaryFontColor
  }
  return{
    selected: {
        background: primaryColor + '!important',
        color: primaryFontText + '!important'
    },
    HeaderMenuButton: {
      backgroundColor: "transparent !important",
      float: "left",
      color: ColorsConstant.white,
      "@media (max-width: 1024px)": {
        marginTop: "10px",
      },
      "@media (max-width: 767px)": {
        color: "#2962ff",
        "& svg": {
          fontSize: 30,
          color: "#fff",
        },
      },
    },
    paper: {},
    drawer: {},
    drawerPaper: {},
    drawerPaperClose: {},
    drawerHeader: {},
    content: {},
    contentShift: {},
    menuButtonHidden: {},
    menuButton: {},
    title: {},
    root: {},
    appBar: {},
    appBarShift: {},
    hide: {},
  }
};

export default withStyles(useStyles, { withTheme: true })(MobileViewSideBar);;
